import React, { createContext, useContext } from "react";

type SSRStatusRef = { statusCode: number };

type SSRStatusContextType = {
    setStatusCode: (code: number) => void;
};

const SSRStatusContext = createContext<SSRStatusContextType>({
    setStatusCode: () => {},
});

export const useSSRStatus = () => useContext(SSRStatusContext);

export const SSRStatusProvider: React.FC<{
    statusRef: SSRStatusRef,
    children: React.ReactNode,
}> = ({ statusRef, children }) => {
    const value = {
        setStatusCode: (code: number) => { statusRef.statusCode = code; },
    };

    return (
        <SSRStatusContext.Provider value={value}>
            {children}
        </SSRStatusContext.Provider>
    );
};

export default SSRStatusContext;
